<template>
  <div>
    <mobile-dialog class="dialog" title="已获得奖励" :visible.sync="dialogVisible" @close="close" @confirm="handleClaim">
      <template #content>
        <div class="list" v-if="hasPrize">
          <div
            v-for="(item, key) in prizeList"
            :key="key"
            class="gift-item"
          >
            <div class="left">
              <div class="image">
                <img :src="getImg(item.icon)" />
              </div>
            </div>
            <div class="right">
              <div class="top"><span>{{ item.name }}</span>{{ item.status == 1 ? '（已领取）' : '' }}</div>
              <div class="expire">有效期：{{ item.effectTime }}</div>
            </div>
          </div>
        </div>
        <div class="empty" v-else>暂无邀请奖励</div>
      </template>
      <template #btn>
        <div class="gift-btn" v-if="hasPrize"></div>
        <div class="confirm-btn" v-else></div>
      </template>
    </mobile-dialog>
    <bind-dialog :visible.sync="bindDialogVisible" :prizeList="prizeList" @success="handleBindSuccess" />
  </div>
</template>

<script>
import MobileDialog from '../dialog/Index.vue'
import BindDialog from '@/views/mobile/components/bindDialog/Index.vue'

import prizeDialogMixins from '@/mixins/prizeDialogMixins.js'

export default {
  name: 'MobilePrizeDialog',
  mixins: [prizeDialogMixins],
  components: {
    MobileDialog,
    BindDialog,
  },
}
</script>

<style lang="scss" scoped>
.dialog ::v-deep {
  .content {
    top: 24vw;
  }

  .btn-box {
    margin-top: 2.666666vw;
  }
}

.list {
  height: 75vw;
  overflow-y: auto;
}

.gift-item {
  display: flex;
  padding-bottom: 2vw;
  border-bottom: .133333vw solid #ddd;

  &:not(:first-of-type) {
    margin-top: 15px;
  }

  .left {
    margin-right: 30px;
  }

  .image {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 18vw;
    height: 16.2vw;
    background: url('~@/assets/img/pc/prize_bg2.png') no-repeat;
    background-size: 100%;

    img {
      max-width: 10.666666vw;
      max-height: 10.666666vw;
    }
  }

  .right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-weight: bold;
    font-family: Noto Serif SC;

    .top {
      margin-bottom: 2.666666vw;
      font-size: 3.2vw;
      
      span {
        font-size: 4.8vw;
        color: #613811;
      }
    }

    .expire {
      font-size: 3.2vw;
      color: #aaa;
    }
  }
}

.empty {
  margin-bottom: 100px;
  text-align: center;
  font-size: 3.2vw;
}

.gift-btn {
  margin: 0 auto;
  width: 40vw;
  height: 10.707069vw;
  background: url('~@/assets/img/pc/gift_btn2.png') no-repeat;
  background-size: 100%;
}
</style>